import { observable, action } from 'mobx';
import { Attachments } from 'api';

class AttachementsStore {
  @observable.shallow files = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getFiles(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Attachments.getFiles(anketId);
      this.files = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const attachmentsStore = new AttachementsStore();

export default attachmentsStore;
